import { GET_CHARGE_DATA, SET_PAST_ORDERS_SHOW } from './types';

export default {
  [GET_CHARGE_DATA]: (state, id) => {
    state.charge = id;
  },
  [SET_PAST_ORDERS_SHOW]: (state, show) => {
    state.pastOrdersShow = show;
  },
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/store/mutations.js